(() => {
	angular
		.module('main')
		.controller('PaymentMethodsController', PaymentMethodsController);

	PaymentMethodsController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'$window',
		'messageService',
		'validationService'
	];

	function PaymentMethodsController(
		$scope,
		$rootScope,
		$http,
		$window,
		messageService,
		validationService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveSpinnningWheelActive = false;
			getAllPaymentMethods();
		});

		function getAllPaymentMethods() {
			$http
				.get('/protected/rest/payment_method')
				.then(result => setPaymentMethods(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function setPaymentMethods(methods) {
			if (!methods.length) {
				return;
			}

			$scope.bankPaymentMethod = findMethodByType('BANK_TRANSFER', methods);
			$scope.otherPaymentMethod = findMethodByType('OTHER', methods);
			$scope.stripePaymentMethod = findMethodByType('STRIPE', methods);
			$scope.paypalPaymentMethod = findMethodByType('PAYPAL', methods);

			if ($scope.stripePaymentMethod) {
				$scope.hasStripe = true;
			}

			if ($scope.paypalPaymentMethod) {
				$scope.hasPayPal = true;
			}
		}

		function findMethodByType(type, methods) {
			return methods.find(method => method.type === type);
		}

		$scope.showDeactivatePaypal = () => {
			$('#delPayPalModal').modal('show');
		};

		$scope.deactivatePaypalModal = () => {
			$scope.hasPayPal = false;
			delete $scope.paypalPaymentMethod.paypalEmail;
			$('#delPayPalModal').modal('hide');
			$scope.savePayPalRequest();
		};

		$scope.showLinkInNewTab = link => {
			$window.open(link);
		};

		$scope.showDeactivate = () => {
			$('#delStripeModal').modal('show');
		};

		$scope.deactivateStripeModal = () => {
			$scope.hasStripe = false;
			delete $scope.stripePaymentMethod.stripePublicKey;
			delete $scope.stripePaymentMethod.stripeSecretKey;
			$('#delStripeModal').modal('hide');
			$scope.saveStripeRequest();
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Payment Methods' }
		];

		function isMethodValid(paymentMethod) {
			const { name, instructions } = paymentMethod;

			if (name !== undefined && name !== null) {
				if (name === '' || name.trim() === '') {
					return false;
				}
			}

			if (!instructions || instructions.trim() === '') {
				return false;
			}

			return true;
		}

		function preparePaymentMethods2Save(method2Save) {
			const method = angular.copy(method2Save);

			if (!method.active) {
				method.active = false;
			}
			return method;
		}

		$scope.savePaymentMethods = () => {
			$scope.isSaveSpinnningWheelActive = true;
			const bankPayment = $scope.bankPaymentMethod;
			const otherPayment = $scope.otherPaymentMethod;

			if (bankPayment.instructions) {
				bankPayment.instructions = $rootScope.addMaiStyling(
					bankPayment.instructions
				);
			}

			if (otherPayment.instructions) {
				otherPayment.instructions = $rootScope.addMaiStyling(
					otherPayment.instructions
				);
			}

			if (bankPayment.active && !isMethodValid(bankPayment)) {
				$scope.isSaveSpinnningWheelActive = false;

				return messageService.showToaster('e_0', 'paymentMethods');
			}

			if (otherPayment.active && !isMethodValid(otherPayment)) {
				$scope.isSaveSpinnningWheelActive = false;

				return messageService.showToaster('e_1', 'paymentMethods');
			}

			$http({
				method: 'POST',
				url: '/protected/rest/payment_method/save',
				data: {
					bankTransferMethod: preparePaymentMethods2Save(bankPayment),
					otherPaymentMethod: preparePaymentMethods2Save(otherPayment)
				}
			})
				.then(() => {
					messageService.showToaster('s_2', 'paymentMethods');
					$scope.isSaveSpinnningWheelActive = false;
				})
				.catch(messageService.showDefaultErrorMessage)
				.finally(() => {
					$scope.isSaveSpinnningWheelActive = false;
				});
		};

		$scope.openStripeModal = () => {
			getPaymetMethodByType('STRIPE').then(result => {
				$scope.stripePaymentMethod = result.data || {};
				$('#addStripeModal').modal('show');
			});
		};

		$scope.saveStripeMethod = () => {
			if (
				!$scope.stripePaymentMethod ||
				!$scope.stripePaymentMethod.stripeSecretKey ||
				!$scope.stripePaymentMethod.stripePublicKey
			) {
				messageService.showToaster('e_4', 'paymentMethods');
			} else {
				$scope.saveStripeRequest();
			}
		};

		$scope.saveStripeRequest = () => {
			$scope.button_disable = true;
			const stipeMethod = $scope.stripePaymentMethod;
			const isStripeActive =
				stipeMethod.stripePublicKey && stipeMethod.stripeSecretKey;
			$http({
				method: 'POST',
				url: '/protected/rest/payment_method/save_stripe',
				data: $scope.stripePaymentMethod
			})
				.then(result => successSaveStripe(result.data, isStripeActive))
				.catch(result => errorSaveStripe(result))
				.finally(() => {
					$scope.button_disable = false;
				});
		};

		function successSaveStripe(data, isStripeActive) {
			if (isStripeActive) {
				$scope.hasStripe = true;
			}
			$('#addStripeModal').modal('hide');
			messageService.showToaster('s_1', 'paymentMethods');
		}

		function errorSaveStripe(result) {
			if (result.status === 422) {
				messageService.showToaster('e_2', 'paymentMethods');
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.openPaypalModal = () => {
			getPaymetMethodByType('PAYPAL').then(result => {
				$scope.paypalPaymentMethod = result.data || {};
				$('#addPaypalModal').modal('show');
			});
		};

		$scope.savePaypalMethod = () => {
			if (
				$scope.paypalPaymentMethod &&
				validationService.isStringEmpty($scope.paypalPaymentMethod.paypalEmail)
			) {
				return messageService.showToaster('e_3', 'paymentMethods');
			}

			if ($scope.paypalPaymentMethod == '') {
				$('#addPaypalModal').modal('hide');
				toastr.success('No changes');
			} else {
				$scope.hasPayPal = true;
				$scope.savePayPalRequest();
			}
		};

		$scope.savePayPalRequest = () => {
			$scope.button_disable = true;
			$http({
				method: 'POST',
				url: '/protected/rest/payment_method/save_paypal',
				data: $scope.paypalPaymentMethod
			})
				.then(result => successSavePayPal(result.data))
				.catch(result => errorSavePayPal(result))
				.finally(() => {
					$scope.button_disable = false;
				});
		};

		function successSavePayPal(data) {
			$('#addPaypalModal').modal('hide');
			messageService.showToaster('s_0', 'paymentMethods');
		}

		function errorSavePayPal(result) {
			if (result.status === 422) {
				messageService.showToaster('e_7', 'paymentMethods');
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function getPaymetMethodByType(type) {
			return $http.get(`/protected/rest/payment_method/get?type=${type}`);
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/paymentMethodsController.js